import React from 'react';
import styled from 'styled-components';
import { Dialog, Item, Icon } from '@zebra-fed/zds-react-desktop';
import '@zebra-fed/icons/Navigation/index.css';
import '@zebra-fed/icons/Enterprise/index.css';
import {useTranslation} from "react-i18next";

const ModalHeader = styled.div`
    display: block;
    font-size: 18px;
    color: #FFF;  
    text-align: right;
`

const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    background: #056DAE;
    padding: 50px;
    padding-top: 22px;
    text-align: left;
    color:#fff;
    line-height: 18px;
`


export default function CompatibilityNotificationModal(props) {
    const dialogRef = props.modalRef;
    const { t } = useTranslation()

    return (
        <>
            <Dialog ref={dialogRef}
                key='dialog2'
                width='700px'
                style={{ cursor: 'default',backgroundColor:"rgba(0,0,0,.8)" }}
                items={[
                   
                ]}
                headerStyle={{ display: 'none' }}
                bodyStyle={{ padding: '0px', width: '100%' }}
                cardStyle={{ marginBottom: '80px',boxShadow:"none",background:"none"}}
                footerStyle={{ display: 'none'}}
            >
                <ModalHeader>
                    <span style={{cursor: "pointer"}} onClick={() => {
                        dialogRef.current.toggleDialog()
                        localStorage.removeItem("compatibilityNotification")
                      }}>X</span>
                </ModalHeader>
                <MainContent >
                    <h4 style={{ marginBottom: '8px' }}><span style={{borderBottom: "1px solid #fff"}}>{t('highlights')}:</span></h4>
                    <div style={{ width: '100%',fontSize: "13px" }}>
                        <ul style={{marginLeft:'30px',padding:0}}>
                            <li>{t('compatibilityNotificationContent4')}</li>
                            <li>{t('compatibilityNotificationContent5')}</li>
                        </ul>
                        {/* <b>{t('compatibilityNotificationContent6')}</b>: {t('compatibilityNotificationContent7')} */}
                        {/* <br/> */}
                        {/* <br/> */}
                        {t("compatibilityNotificationContent2")}
                        <a style={{
                          textDecoration: "none",
                          color:"#fff",
                          fontWeight:"bold",
                         
                          
                        }} href='https://techdocs.zebra.com/devicetracker' target='__blank'>TechDocs</a> 
                    </div>
                    <div style={{ width: '100%',fontSize: "13px"}}>
                        {t("support")}
                        <a style={{
                          textDecoration: "none",
                          color:"#fff",
                          fontWeight:"bold"
                        }} href='https://www.zebra.com/us/en/support-downloads/software/productivity-apps/device-tracker.html' target='__blank'>{t("support1")}</a>
                        {t("support2")}
                    </div>
                    
                </MainContent>
            </Dialog>
        </>
    )
}